export class EventEmitter
{
    protected listeners: { [key: string]: Function[] } = {};

    // Attach event listener
    public on(eventName: string, fn: Function): this
    {
        this.addListener(eventName, fn);
        return this;
    }

    // Attach event handler only once. Automatically removed.
    public once(eventName: string, fn: Function): this
    {
        this.listeners[eventName] = this.listeners[eventName] || [];
        const onceWrapper = () =>
        {
            fn();
            this.off(eventName, onceWrapper);
        };
        this.listeners[eventName].push(onceWrapper);

        return this;
    }

    // Alias for removeListener
    public off(eventName: string, fn: Function): this
    {
        this.removeListener(eventName, fn);
        return this;
    }

    // Fire the event
    public trigger(eventName: string, args: object = {}): boolean
    {
        let functions = this.listeners[eventName];
        if (!functions) return false;
        functions.forEach((func) =>
        {
            func(args);
        });

        return true;
    }

    public listenerCount(eventName): number
    {
        let functions = this.listeners[eventName] || [];

        return functions.length;
    }

    // Get raw listeners
    // If the once() event has been fired, then that will not be part of the return array
    public rawListeners(eventName): Function[]
    {
        return this.listeners[eventName];
    }

    protected addListener(eventName: string, fn: Function): this
    {
        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(fn);

        return this;
    }

    protected removeListener(eventName, fn): this
    {
        let listener = this.listeners[eventName];
        if (!listener) return this;
        for (let i = listener.length; i > 0; i--)
        {
            if (listener[i] === fn)
            {
                listener.splice(i, 1);
                break;
            }
        }

        return this;
    }

}
